import { useMemo } from 'react';

import { getIdsWithNoParentsInSameList } from '@hh.ru/magritte-ui-tree-selector/collection/treeCollectionHelper';
import { AdditionalDefault } from '@hh.ru/magritte-ui-tree-selector/collection/types';
import { TreeSelectorProps } from '@hh.ru/magritte-ui-tree-selector/types';

type UseDisabledHookProps<Additional extends AdditionalDefault> = {
    selected: string[];
} & Pick<TreeSelectorProps<Additional>, 'disabled' | 'collection' | 'maxSelected'>;
interface UseDisabledHook {
    <Additional extends AdditionalDefault>(props: UseDisabledHookProps<Additional>): string[] | undefined;
}

export const useDisabled: UseDisabledHook = ({ selected, disabled, collection, maxSelected }) => {
    return useMemo(() => {
        const valueIds = getIdsWithNoParentsInSameList(collection, selected);
        if (maxSelected && valueIds.length >= maxSelected) {
            return collection
                .toList()
                .map(({ id }) => id)
                .filter((id) => !selected.includes(id));
        }
        return disabled;
    }, [selected, collection, disabled, maxSelected]);
};
